import {
  GET_COMPANY_STRUCTURE_REQUEST,
  GET_COMPANY_STRUCTURE_REQUEST_FAILED,
  GET_COMPANY_STRUCTURE_REQUEST_SUCCEEDED
} from "../constants/structure";

export const structure = (
  state = {
    isFetching: false,
    data: { units: []},
    error: {}
  }, action) => {
  let newState = {...state};

  switch (action.type) {
    case GET_COMPANY_STRUCTURE_REQUEST:
      newState.isFetching = true;
      return newState;

    case GET_COMPANY_STRUCTURE_REQUEST_SUCCEEDED:
      newState.isFetching = false;
      newState.data = action.data.units;
      newState.error = {};
      return newState;

    case GET_COMPANY_STRUCTURE_REQUEST_FAILED:
      newState.isFetching = false;
      newState.error = action.error;
      newState.data = {};
      return newState;

    default:
      return newState;
  }
};
